import { createAction } from '@reduxjs/toolkit';

export const newError = createAction('error/newError', (
  error: unknown,
) => ({
  payload: { error },
}));
